module.exports = __webpack_public_path__ + "img/headLeft1.1d0874b3.png";